import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import { VacancyLink } from '../types';

interface ShareVacancyFormProps {
    vacancyLinks: VacancyLink[];
    onAddVacancyLink: () => void;
}

interface ShareVacancyFormState {
    showInvitationSentNotification: boolean;
}

class ShareVacancyForm extends React.Component<ShareVacancyFormProps, ShareVacancyFormState> {
    constructor(props: ShareVacancyFormProps) {
        super(props);
    }

    public render() {
        const vacancyLinks = this.props.vacancyLinks.sort(
            (a, b) => new Date(a.validUntil).getDate() - new Date(b.validUntil).getDate()
        );
        return (
            <div>
                <p>
                    You can generate links to share with your potential candidates. All generated links are valid one
                    week.
                </p>
                <ul>
                    {vacancyLinks.map((vacancyLink) => (
                        <li key={vacancyLink.id}>
                            <Link to={`/vacancy/${vacancyLink.id}`}>Valid until {vacancyLink.validUntil}</Link>
                        </li>
                    ))}
                </ul>
                <Button onClick={this.props.onAddVacancyLink}>Generate new link</Button>
            </div>
        );
    }
}

export default ShareVacancyForm;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/ShareVacancyForm.tsx